import { lazyLoad } from 'utils/loadable';

export const RoleListPage = lazyLoad(
  () => import('./index'),
  module => module.RoleListPage,
);
